import React, { PropsWithChildren } from 'react';
import classes from './About.module.scss';
import Typography from 'new/elements/Typography';

interface AboutProps {}

export const About = (props: PropsWithChildren<AboutProps>) => {
  const { children } = props;
  return (
    <div className={classes.container}>
      <Typography className={classes.about}>{children}</Typography>
    </div>
  );
};
